import React, { Component } from "react";
import WarningMessage from "./../../Common/Layout/WarningMessage";
import {
  Button,
  Modal,
  Icon
} from "semantic-ui-react";
import { showModal } from "./../../actions/categories/showModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import AddCategoryForm from "./AddCategoryForm";
import { isEdited } from "./../../actions/categories/isEdited";

import TaskCount from "./TaskCount";
import { addCategory } from "./../../actions/categories/addCategory";

import { isValid, isSubmitting, submit } from "redux-form";

class ModalPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      payload: props.modalPayload,
      submitBtn:
        props.modalContentComponent == "ADD_CATEGORY_FORM" ? "Submit" : "Yes"
    };
  }

  onClose = () => {
    // dispatch show modal acction here
    this.props.showModal({
      state: false,
      modalName: this.props.showModal.modalName,
      component: this.props.modalContentComponent,
      size: "small",
      submitBtn: this.props.showModal.submitBtn,
      denyBtn: this.props.showModal.denyBtn,
      payload: this.props.showModal.payload
    });
  };

  handleSubmit = () => {
    this.setState({
      submit: true
    });
  };

  setToFalse = langValue => {
    this.setState({ submit: langValue });
  };

  onSubmit = form => {
    const todayDate = moment().format("MM/DD/YY");

    const addCatObj = {
      cat_Order: this.props.categories.length + 1,
      category_id:
        Math.max(...this.props.categories.map(elem => elem.category_id)) + 1,
      firm_id: this.props.user.firm,
      is_custom: true,
      name: "",
      code: "",
      type: "",
      updated_on: todayDate,
      updated_by: this.props.user.id,
      updated_byName: this.props.user.name,
      is_active: true,
      extension_section: false,
      hasLinkedDueDates: 0
    };

    Object.keys(form).forEach((key) => form[key] = (form[key]).trim());

    this.props.addCategory(this.props.categories, { ...addCatObj, ...form });
    this.props.showModal({
      state: false,
      modalName: "Add Category",
      component: "ADD_CATEGORY_FORM",
      size: "small",
      submitBtn: "Submit",
      denyBtn: "Cancel"
    });
  };

  render() {
    return (
      <Modal
        open={this.props.shouldShowModal}
        closeOnDimmerClick={false}
        centered={true}
        size="small"
      >
        <Modal.Header>
          {this.props.modalName}
          <Icon
            style={{
              display: "inlineBlock",
              float: "right",
              cursor: "pointer"
            }}
            name="close"
            onClick={this.onClose}
            // size="large"
          />
        </Modal.Header>
        <Modal.Content
          scrolling={true}
          style={{ overflow: "initial", paddingBottom: "35px" }}
        >
          {this.props.modalContentComponent == "ADD_CATEGORY_FORM" ? (
            <AddCategoryForm
              onSubmit={this.onSubmit}
              payload={this.props.modalPayload}
            />
          ) : (
            <TaskCount
              submit={this.state.submit}
              payload={this.props.modalPayload}
              setFalse={this.setToFalse}
              hotInstanceProps={this.props.hotInstanceProps}
              changedRows={this.props.changedRows}
            />
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="Cancel"
            onClick={this.onClose}
          />
          <Button
            content={this.props.modalSubmitBtn}
            primary
            disabled={!this.props.formEnabled}
            onClick={
              this.props.modalContentComponent === "ADD_CATEGORY_FORM"
                ? this.props.submitForm
                : this.handleSubmit
            }
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    showModal: state.allCategories.showModal,
    shouldShowModal: state.allCategories.showModal.state,
    modalContentComponent: state.allCategories.showModal.component,
    modalSubmitBtn: state.allCategories.showModal.submitBtn,
    modalDenyBtn: state.allCategories.showModal.denyBtn,
    modalName: state.allCategories.showModal.modalName,
    modalPayload: state.allCategories.showModal.payload,
    formEnabled:
      isValid("child-form")(state) && !isSubmitting("child-form")(state)
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showModal,
      addCategory,
      isEdited,
      submitForm: () => submit("AddCategoryForm")
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalPopup);
